import React from 'react'
import styled from 'styled-components/macro'
import { dragDrop, welcomePage } from '../question-types/QuestionTypes'

const PositionLeft = styled.div`
  width: 25%;
  position: absolute;
  left: 70px;
  top: 45px;
`

const DragDropDemo = {
  questions: [
    {
      id: 'intro-page',
      type: welcomePage,
      text: 'intro-page',
    },
    {
      id: 'Q1',
      type: dragDrop,
      statement: () => {
        return (
          <PositionLeft>
            <h5>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
              dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum
            </h5>
          </PositionLeft>
        )
      },
      CompanyName: 'DairyNZ',
      zoneOrder: ['zone-1', 'zone-2', 'zone-3', 'start-zone'],
      dropZones: {
        'zone-1': {
          id: 'zone-1',
          title: 'zone-1',
          info: 'Strongest',
          items: [
            { id: 1, content: 'I am label 1' },
            { id: 2, content: 'I am label 2' },
          ],
          maxItems: 3,
          color: '#8bea97',
        },
        'zone-2': {
          id: 'zone-2',
          title: 'zone-2',
          info: 'Strong',
          items: [],
          maxItems: 5,
          color: '#bef7c6',
        },
        'zone-3': {
          id: 'zone-3',
          title: 'zone-3',
          info: 'Weakest',
          items: [{ id: 4, content: 'I am label 4' }],
          color: '#e6ffe9',
        },
        'start-zone': {
          id: 'start-zone',
          title: 'Inactive',
          info: 'Inactive',
          items: [
            { id: 5, content: 'I am label 5' },
            { id: 6, content: 'I am label 6' },
            { id: 7, content: 'I am label 7' },
            { id: 8, content: 'I am label 8' },
            { id: 9, content: 'I am label 9' },
          ],
          color: 'white',
        },
      },
    },
  ],
  settings: {
    hideSubmit: true,
    surveyWidth: '100%',
    writeToFirestore: false,
    surveyName: 'dragdropdemo',
  },
}

export default DragDropDemo
